"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = void 0;
const useTheme_1 = require("./useTheme");
const useMediaQuery_1 = require("./useMediaQuery");
function useBreakpoints(valueForBreakpoint) {
    const theme = useTheme_1.useTheme();
    const isXs = !useMediaQuery_1.useMediaQuery(`(min-width: ${theme.breakpoints[0]})`);
    const isSm = !useMediaQuery_1.useMediaQuery(`(min-width: ${theme.breakpoints[1]})`);
    const isMd = !useMediaQuery_1.useMediaQuery(`(min-width: ${theme.breakpoints[2]})`);
    const isLg = !useMediaQuery_1.useMediaQuery(`(min-width: ${theme.breakpoints[3]})`);
    const isXl = !useMediaQuery_1.useMediaQuery(`(min-width: ${theme.breakpoints[4]})`);
    if (isXs) {
        return valueForBreakpoint[0];
    }
    if (isSm) {
        return valueForBreakpoint[1];
    }
    if (isMd) {
        return valueForBreakpoint[2];
    }
    if (isLg) {
        return valueForBreakpoint[3];
    }
    if (isXl) {
        return valueForBreakpoint[4];
    }
    return valueForBreakpoint[5];
}
exports.useBreakpoints = useBreakpoints;
//# sourceMappingURL=useBreakpoints.js.map